// extracted by mini-css-extract-plugin
export var content = "_qy-1";
export var fullScreen = "_qy-0";